module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-300.b1d5fa32.svg";